<template>
  <div v-if="global.selectedAppTab == 4">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Langues </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row
              v-if="
                clientPortal.portalConfigurationModel.languages != null &&
                clientPortal.portalConfigurationModel.languages.length > 0
              "
            >
              <v-col cols="12" md="2">
                <switch-confirm
                  :value.sync="clientPortal.isInherit"
                  v-on:confirm="updateInheritPortal(clientPortal.id)"
                  :loading="isLoading"
                  :dense="true"
                  color="green"
                  class="ml-2"
                  :disabled="!clientPortal.group || !isGrantedUser()"
                  label="Héritage groupe"
                >
                  <template #confirm-text>
                    Êtes-vous sûr.e de vouloir
                    {{ !clientPortal.isInherit ? "désactiver" : "activer" }}
                    l'héritage de groupe sur ce portail ?
                  </template>
                </switch-confirm>
                <v-subheader class="text-caption" v-if="!clientPortal.group">
                  Ce portail n'est pas associé à un groupe
                </v-subheader>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  label="Langue par défault"
                  v-model="clientPortal.portalConfiguration.default_language"
                  :items="clientPortal.portalConfiguration.languages"
                  :rules="rules.default_languageRules"
                  :loading="loadingLanguages"
                  :disabled="!isGrantedUser()"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <div>Langues disponibles</div>
                <v-layout row wrap class="px-3">
                  <div
                    class="inline-block mr-2"
                    v-for="(language, index) in clientPortal
                      .portalConfigurationModel.languages"
                    :key="index"
                  >
                    <v-checkbox
                      :rules="rules.languagesRules"
                      :key="language"
                      v-model="clientPortal.portalConfiguration.languages"
                      :label="language.toUpperCase()"
                      :value="language"
                      :disabled="
                        !isGrantedUser() ||
                        (clientPortal.portalConfiguration.languages.length ==
                          1 &&
                          clientPortal.portalConfiguration.languages[0] ==
                            language)
                      "
                    ></v-checkbox>
                  </div>
                </v-layout>
                <v-progress-linear
                  indeterminate
                  rounded
                  v-if="loadingLanguages"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <confirm-dialog
              :open.sync="openConfirmDialog"
              :loading="loadingLanguages"
              v-on:cancel="cancelLanguagesChanges"
              v-on:confirm="updateLanguages(clientPortal.id)"
            >
              <template #title> Demande de confirmation </template>
              <slot name="confirm-text">
                Êtes-vous sûr.e de vouloir changer cette valeur ?
              </slot>
            </confirm-dialog>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <client-portal-translation
      v-if="
        clientPortal.portalConfiguration.languages != null &&
        clientPortal.portalConfiguration.languages.length > 0 &&
        !clientPortal.isInherit
      "
      :languages="clientPortal.portalConfiguration.languages"
    ></client-portal-translation>

    <v-row v-else-if="clientPortal.isInherit">
      <v-col>
        <v-card>
          <v-card-text>
            Le portail étant en héritage groupe, la surcharge de traduction se
            fait donc au niveau du groupe seulement.
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {
  defineComponent,
  toRefs,
  ref,
  onMounted,
  watch,
} from "@vue/composition-api";
import global from "@/composables/global";
import { useClientPortal } from "@/composables/client-portal";
import ClientPortalTranslation from "@/components/ClientPortal/ClientPortalTranslation";
import SwitchConfirm from "@/components/General/SwitchConfirm.vue";
import ConfirmDialog from "@/components/General/ConfirmDialog.vue";
import { useRoles } from "../../composables/roles";

export default defineComponent({
  components: {
    ClientPortalTranslation,
    SwitchConfirm,
    ConfirmDialog,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    /* import des API */
    const { data, updatePortalConfigurationSparse } = useClientPortal();
    const { isGrantedUser } = useRoles();

    /* Cycle de vie */
    onMounted(() => {
      originalLanguages.defaultLanguage =
        props.clientPortal.portalConfiguration.default_language;
      originalLanguages.selectedLanguages =
        props.clientPortal.portalConfiguration.languages;
    });

    /* Variables */
    const loadingLanguages = ref(false);
    const openConfirmDialog = ref(false);
    const originalLanguages = {
      selectedLanguages: [],
      defaultLanguage: "",
    };

    /* Méthodes */
    const updateInheritPortal = async function (id) {
      loadingLanguages.value = true;
      // need update && clarification for this button
      console.log(id);
      /*const formData = {
        default_language: props.group.portalConfiguration.default_language,
        languages: props.group.portalConfiguration.languages,
      };
      await updatePortalConfigurationSparse(String(id), formData);
      originalLanguages.defaultLanguage =
        props.group.portalConfiguration.default_language;
      originalLanguages.selectedLanguages =
        props.group.portalConfiguration.languages;*/
      loadingLanguages.value = false;
    };

    const updateLanguages = async (id) => {
      loadingLanguages.value = true;
      const formData = {
        default_language:
          props.clientPortal.portalConfiguration.default_language,
        languages: props.clientPortal.portalConfiguration.languages,
      };
      await updatePortalConfigurationSparse(String(id), formData);

      originalLanguages.defaultLanguage =
        props.clientPortal.portalConfiguration.default_language;
      originalLanguages.selectedLanguages =
        props.clientPortal.portalConfiguration.languages;
      loadingLanguages.value = false;
    };

    const cancelLanguagesChanges = function () {
      openConfirmDialog.value = true;
      props.clientPortal.portalConfiguration.default_language =
        originalLanguages.defaultLanguage;
      props.clientPortal.portalConfiguration.languages =
        originalLanguages.selectedLanguages;
    };
    const areEquals = function (a, b) {
      if (a && b) {
        let result = true;
        let first = a;
        let second = b;

        if (a.length < b.length) {
          first = b;
          second = a;
        }

        for (let i = 0; i < first.length; i++) {
          if (second.indexOf(first[i]) < 0) {
            result = false;
            break;
          }
        }

        return result;
      } else {
        return true;
      }
    };

    /* Watchers */
    watch(
      () => props.clientPortal.portalConfiguration.default_language,
      (newValue, oldValue) => {
        if (
          newValue &&
          newValue != originalLanguages.defaultLanguage &&
          oldValue &&
          !loadingLanguages.value &&
          global.selectedAppTab == 4
        ) {
          openConfirmDialog.value = true;
        } else {
          openConfirmDialog.value = false;
        }
      },
      { deep: true }
    );
    watch(
      () => props.clientPortal.portalConfiguration.languages,
      (newValue, oldValue) => {
        if (!areEquals(newValue, oldValue) && !openConfirmDialog.value) {
          openConfirmDialog.value = true;
        } else {
          openConfirmDialog.value = false;
        }
      },
      { deep: true }
    );

    return {
      updateLanguages,
      global,
      updateInheritPortal,
      cancelLanguagesChanges,
      ...toRefs(data),
      openConfirmDialog,
      loadingLanguages,
      isGrantedUser,
      updatePortalConfigurationSparse,
    };
  },
});
</script>
